module.exports = __webpack_public_path__ + "static/knight_image-ab9cae82c307b023e33f4b616aa776e0.png";